@if(visible()){
<div class="jk-multiselect-border">
  <table class="jk-margin0">
    <tr class="jk-margin0">
      <td>
        <!-- <mat-label class="jk-field-lable">
          {{label()}}
        </mat-label>
        @if(required){
        <mat-label style="color:red">*</mat-label>
        } -->
        <app-jkfieldlabel [displayLabel]="displayLabel()" [label]="label()" [required]="required()"
          [emojiLabel]="emojiLabel()"></app-jkfieldlabel>
      </td>
      <td>
        <div class="example-button-row">
          <div class="example-flex-container">
            <div class="example-button-container">
              <button mat-mini-button class="jk-button-small" fill="outline" color="primary"
                (click)="doOpenWinClick($event)">選</button>
              <button mat-mini-button class="jk-button-small" fill="outline" (click)="onClear($event)">清</button>
              <button mat-mini-button class="jk-button-small" color="secondary" (click)="onImport($event)">匯</button>
            </div>
          </div>
        </div>
      </td>
    </tr>
  </table>
  <div class="jk-multiselect-list ">
    <table mat-table [dataSource]="internalDataSource()">
      <!-- Name Column -->
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef> 代號 </th>
        <td mat-cell *matCellDef="let item" style="height: 12px;"> {{item.id}} </td>
      </ng-container>
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef> 簡號 </th>
        <td mat-cell *matCellDef="let item" style="height: 12px;"> {{item.name}} </td>
      </ng-container>
      <ng-container matColumnDef="btn">
        <th mat-header-cell *matHeaderCellDef> * </th>
        <td mat-cell *matCellDef="let item" style="height: 12px;">
          <button mat-mini-button class="jk-button-small" (click)="onDelete(item.id)">刪</button>
        </td>
      </ng-container>

      <tr class="text-blue-800" mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
    <mat-paginator #paginator [pageSizeOptions]="[5]" showFirstLastButtons
      aria-label="Select page of periodic elements">
    </mat-paginator>
    <!-- @for (item of values; track item) {
      <table class="jk-margin0">
        <tr class="jk-margin0">
          <td class="jk-margin0">
            {{item.id}}
          </td>
          <td class="jk-margin0">
            &nbsp;({{item.name}})
          </td>
          <td class="jk-margin0">
            <button mat-mini-button class="jk-button-small" (click)="onDelete(item.id)">刪</button>
          </td>
        </tr>
      </table>
    } -->
  </div>
</div>
}